(function () {
    function copyText(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        // Fallback for browsers/contexts without the async Clipboard API.
        return new Promise(function (resolve, reject) {
            var helper = document.createElement('textarea');
            helper.value = text;
            helper.style.position = 'fixed';
            helper.style.opacity = '0';
            document.body.appendChild(helper);
            helper.select();
            var ok = false;
            try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
            document.body.removeChild(helper);
            ok ? resolve() : reject();
        });
    }

    function addCopyButton(pre) {
        var code = pre.querySelector('code');
        if (!code) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'imr-code-copy';
        btn.textContent = 'copiar';

        btn.addEventListener('click', function () {
            copyText(code.textContent).then(function () {
                btn.textContent = 'copiado';
                btn.classList.add('is-copied');
                setTimeout(function () {
                    btn.textContent = 'copiar';
                    btn.classList.remove('is-copied');
                }, 1600);
            }, function () {
                btn.textContent = 'error';
                setTimeout(function () { btn.textContent = 'copiar'; }, 1600);
            });
        });

        pre.appendChild(btn);
    }

    function init() {
        document.querySelectorAll('.gh-content pre > code').forEach(function (code) {
            addCopyButton(code.parentElement);
        });

        if (window.Prism) {
            // prism-autoloader defaults to fetching language grammars relative
            // to its own <script src>, which points at our theme, not a CDN —
            // point it at the CDN folder that actually has them.
            if (Prism.plugins && Prism.plugins.autoloader) {
                Prism.plugins.autoloader.languages_path = 'https://cdn.jsdelivr.net/npm/prismjs@1/components/';
            }
            Prism.highlightAll();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
